import {
  LogLevel,
  PublicClientApplication,
  type Configuration,
  type RedirectRequest,
} from '@azure/msal-browser';
import { env, requireEnv } from '@/shared/config/env';

/**
 * MSAL setup for Entra External ID. MSAL owns the token cache (localStorage) and renews access
 * tokens itself inside acquireTokenSilent, so the app never stores or refreshes tokens by hand.
 */
const msalConfig: Configuration = {
  auth: {
    clientId: requireEnv('VITE_MSAL_CONFIG_AUTH_CLIENT_ID'),
    authority: requireEnv('VITE_MSAL_AUTHORITY'),
    knownAuthorities: env.msal.knownAuthorities,
    redirectUri: env.msal.redirectUri ?? `${window.location.origin}/`,
    postLogoutRedirectUri: env.msal.postLogoutRedirectUri,
  },
  cache: { cacheLocation: 'localStorage' },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
      loggerCallback: (level, message) => {
        if (!env.isDev) return;
        if (level === LogLevel.Error) console.error(message);
        else if (level === LogLevel.Warning) console.warn(message);
      },
    },
  },
};

/** Scopes for the BFF. MSAL adds openid, profile and offline_access (refresh token) itself. */
export const loginRequest: RedirectRequest = {
  scopes: [requireEnv('VITE_MSAL_CONFIG_PUBLIC_SCOPE')],
};

/** The one MSAL instance for the app. Initialised by `initAuth()` before the first render. */
export const msalInstance = new PublicClientApplication(msalConfig);
